



























import Vue from 'vue';
import Component from 'vue-class-component';
import CheckoutElementLayout from './CheckoutElementLayout.vue';
import { Prop, Watch } from 'vue-property-decorator';
import { PaymentMethodViewObject, PaymentMethodType } from '@/types/apiServerContract';
import { Validatable } from '@/project/app/client-pages/checkout/types';
import PageToaster from '@/project/ui-components/PageToaster.vue';

@Component({
    components: { CheckoutElementLayout, PageToaster },
    model: {
        prop: 'paymentMethodCode',
        event: 'paymentMethodCodeUpdated'
    }
})
export default class CheckoutPayment extends Vue implements Validatable {
    private selectedPayment: PaymentMethodViewObject | null = null;
    private validationError = false;

    @Prop(Array)
    private paymentMethods!: PaymentMethodViewObject[] | null;

    @Prop(Boolean)
    private isPartDelivery!: boolean;

    @Prop(String)
    private paymentMethodCode!: string | null;

    @Prop(Boolean)
    private dataLoaded!: boolean;

    @Prop(Boolean)
    private isErpAvailable!: boolean;

    @Watch('paymentMethodCode')
    private onPaymentMethodCodeChange() {
        this.updateChoice();
    }

    @Watch('isPartDelivery')
    private onIsPartDeliveryChange() {
        this.updateChoice();
    }

    private updateChoice() {
        this.validationError = false;
        let newSelectedPayment = this.paymentMethods?.find(pm => pm.paymentMethodCode === this.paymentMethodCode) ?? null;
        if (newSelectedPayment?.isCreditCard && this.isPartDelivery) {
            // Not allowed - select other if only 2
            if (this.paymentMethods?.length === 2) {
                newSelectedPayment = this.paymentMethods?.find(pm => !pm.isCreditCard) ?? null;
            } else {
                newSelectedPayment = null;
            }
        }

        if (newSelectedPayment !== this.selectedPayment) {
            this.selectedPayment = newSelectedPayment;
            this.$emit('paymentMethodCodeUpdated', newSelectedPayment?.paymentMethodCode);
            this.$emit('update:creditcard', newSelectedPayment?.isCreditCard);
        }
    }

    @Watch('selectedPayment')
    private onSelectedPaymentChange(value: PaymentMethodViewObject) {
        this.$emit('paymentMethodCodeUpdated', value.paymentMethodCode);
        this.$emit('update:creditcard', value.isCreditCard);
    }

    private creditcardNotPossible(paymentMethod: PaymentMethodViewObject): boolean {
        return this.isPartDelivery && paymentMethod.isCreditCard;
    }

    public validate(): Promise<boolean> {
        const valid = this.isErpAvailable ? this.selectedPayment !== null : true;

        this.validationError = !valid;
        return Promise.resolve(valid);
    }

    private showToaster() {
        return this.selectedPayment?.type === PaymentMethodType.Prepaid;
    }
}
